/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-10.
 * Form configuration for "aduana"
 */
import { TEXT, SELECT } from '../components/data-containers/formBuilder/types';
import { OWNOFFICE } from '../data/selects';


export const getConfig = (actions = {}) => {
    return {
        fields: [
            {
                fType: TEXT,
                key: 'name',
                floatingLabelFixed: true,
                floatingLabelText: 'Nombre',
                hintText: 'Manzanillo, México...',
                fullWidth: true
            },
            {
                fType: SELECT,
                key: 'ownOffice',
                floatingLabelText: '¿Cuenta con oficina propia?',
                floatingLabelFixed: true,
                data: OWNOFFICE
            },
            {
                fType: TEXT,
                key: 'section',
                floatingLabelFixed: true,
                floatingLabelText: 'Sección',
                hintText: '00',
                fullWidth: true
            },
            {
                fType: TEXT,
                key: 'customsNumber',
                floatingLabelFixed: true,
                floatingLabelText: 'Número',
                hintText: '00',
                fullWidth: true
            }
        ],
        rules: {
            customsNumber: [{ key: 'required', errorText: 'Campo requerido' }],
            section: [{ key: 'required', errorText: 'Campo requerido' }],
            name: [{ key: 'required', errorText: 'Campo requerido' }],
        }
    };
};



// WEBPACK FOOTER //
// ./forms/aduana.js